import { render, staticRenderFns } from "./nota.vue?vue&type=template&id=39dc87f6&scoped=true&"
import script from "./nota.vue?vue&type=script&lang=js&"
export * from "./nota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc87f6",
  null
  
)

export default component.exports